import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './index.css'

import { QueryParamProvider } from 'use-query-params'

const container = document.getElementById('root')
if (container) {
  const root = createRoot(container)
  root.render(
    <React.StrictMode>
      <QueryParamProvider>
        <App />
      </QueryParamProvider>
    </React.StrictMode>,
  )
}
